import { Col, Row } from "antd";
import Logo from "src/assets/images/logo_new.png";
import { Icon } from "src/components/common/icons";
import IconFacebook from "src/assets/images/IconFaceBook.svg";
import IconYoutube from "src/assets/images/IconYoutube.svg";
import IconTiktok from "src/assets/images/IconTiktok.svg";

function Footer() {
  return (
    <footer className="p-12 pb-6 mt-20" style={{ backgroundColor: "rgba(2, 2, 2, 0.45)" }}>
      <img src={Logo} className="max-w-[175px] w-full" alt=""/>
      <Row className="mt-8" gutter={[24, 24]}>
        <Col lg={8} xs={24} className="pr-2">
          <h4 className="text-lg">TRANG BÁN VÉ CHÍNH THỨC CỦA MELODY SHOW</h4>
          <p className="mt-4">Hotline:</p>
          <p className="flex text-[16px] leading-[26px] mt-1">
            <Icon name="phone" className="mr-4 w-[17px]" />
            <span>0918222135</span>
          </p>
          <p className="flex text-[16px] leading-[26px] mt-1 ml-8">
            <span>02293580888</span>
          </p>
          <p className="mt-4">Email:</p>
          <p className="flex text-[16px] leading-[26px] mt-1">
            <Icon name="email" className="mr-4 w-[17px]" />
            <span>Tochucsukiensacviet@gmail.com</span>
          </p>
          <p className="mt-4">
            Văn phòng: <span></span>
          </p>
          <p className="flex text-[16px] mt-1">
            <Icon name="direction" className="mr-4 w-[17px]" />
            <span>Số 73 đường Tuệ Tĩnh, xã Ninh Tiến, Thành phố Hoa Lư, Tỉnh Ninh Bình</span>
          </p>
        </Col>
        <Col lg={8} xs={24} className="pr-2">
          <h4 className="text-xl">CÔNG TY TNHH DỊCH VỤ VÀ GIẢI TRÍ SẮC VIỆT</h4>
          <p className="mt-4">
            Trụ sở văn phòng: Số 73 đường Tuệ Tĩnh, xã Ninh Tiến, Thành phố Hoa Lư, Tỉnh Ninh Bình
          </p>
        </Col>
        <Col lg={8} xs={24} className="pr-2">
          <h4>Follow US</h4>
          <div className="flex mt-4">
            <a href="/" target="_blank">
              <img className="mr-4" src={IconFacebook} alt=""/>
            </a>
            <a href="/" target="_blank">
              <img className="mr-4" src={IconYoutube} alt=""/>
            </a>
            <a href="/" target="_blank">
              <img src={IconTiktok} alt=""/>
            </a>
          </div>
        </Col>
        <div className="w-full mt-4 pt-4 border-t border-solid border-[#fff]">
          <h6 className="text-center">BẢN QUYỀN BỞI SẮC VIỆT EVENT</h6>
        </div>
      </Row>
    </footer>
  );
}

export default Footer;
